import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import ProgressBar from "../components/ProgressBar";

import bgCity from "../images/city.png";
import countries from "../data/countries.json";
import citiesData from "../data/cities";

const Step4 = () => {
  const student = JSON.parse(localStorage.getItem("student"));

  const [country, setCountry] = useState("");
  const [province, setProvince] = useState("");
  const [city, setCity] = useState("");

  const [provinceList, setProvinceList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (country === "Indonesia") {
      setProvinceList(Object.keys(citiesData));
      setProvince("");
      setCity("");
      setCityList([]);
    } else {
      setProvince("");
      setCity("");
      setProvinceList([]);
      setCityList([]);
    }
  }, [country]);

  useEffect(() => {
    if (country === "Indonesia" && province) {
      setCityList(citiesData[province]);
      setCity("");
    }
  }, [province, country]);

  const validate = () => {
    if (!country) return "Please select your country";

    if (country === "Indonesia") {
      if (!province) return "Please select a province";
      if (!city) return "Please select a city";
    } else {
      if (!city) return "Please enter your city";
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      const response = await fetch(
         `http://localhost:3000/api/student-demography/${student.student_id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            city: city,
            current_step: "5",
          }),
        }
      );

      if (response.ok) {
        setTimeout(() => {
          window.location.href = "/step5";
        }, 700);
      } else {
        alert("Failed to save city");
      }
    } catch (err) {
      console.error("Error updating city:", err);
      alert("Server error");
    }
  };

  return (
    <div className="relative flex flex-col items-center min-h-screen bg-blue-900 text-white px-4">
      <img
        src={bgCity}
        className="absolute inset-0 w-full h-full object-cover opacity-25"
        alt="city background"
      />

      <div className="w-full max-w-lg mt-6 z-10">
        <ProgressBar step={4} />
      </div>

      <motion.h1
        className="text-3xl md:text-4xl font-bold mt-12 text-center text-yellow-300 drop-shadow-md z-10"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        WHICH CITY DO YOU LIVE IN?
      </motion.h1>

      <form
        onSubmit={handleSubmit}
        className="mt-10 bg-white/15 backdrop-blur-xl p-8 rounded-3xl shadow-xl w-full max-w-md z-10"
      >
        <label className="text-sm text-yellow-200 font-semibold">Country</label>
        <select
          value={country}
          onChange={(e) => setCountry(e.target.value)}
          className="w-full mt-1 px-4 py-3 rounded-full border-2 border-yellow-300 text-blue-900 font-semibold text-lg"
        >
          <option value="">Select country</option>
          {countries.map((c, i) => (
            <option key={i} value={c.name}>
              {c.name}
            </option>
          ))}
        </select>

        {country === "Indonesia" && (
          <>
            <label className="text-sm text-yellow-200 font-semibold mt-5 block">
              Province
            </label>
            <select
              value={province}
              onChange={(e) => setProvince(e.target.value)}
              className="w-full mt-1 px-4 py-3 rounded-full border-2 border-yellow-300 text-blue-900 font-semibold text-lg"
            >
              <option value="">Select province</option>
              {provinceList.map((prov, idx) => (
                <option key={idx} value={prov}>
                  {prov}
                </option>
              ))}
            </select>

            <label className="text-sm text-yellow-200 font-semibold mt-5 block">
              City / Regency
            </label>
            <select
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className="w-full mt-1 px-4 py-3 rounded-full border-2 border-yellow-300 text-blue-900 font-semibold text-lg"
            >
              <option value="">Select city</option>
              {cityList.map((ct, idx) => {
                const label = typeof ct === "object" ? ct.name : ct;
                return (
                  <option key={idx} value={label}>
                    {label}
                  </option>
                );
              })}
            </select>
          </>
        )}

        {country && country !== "Indonesia" && (
          <>
            <label className="text-sm text-yellow-200 font-semibold mt-5 block">
              City
            </label>
            <input
              type="text"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              placeholder="Enter your city"
              className="w-full mt-1 px-4 py-3 rounded-full border-2 border-yellow-300 text-blue-900 font-semibold text-lg"
            />
          </>
        )}

        {error && (
          <p className="text-red-200 text-sm mt-3 text-center">{error}</p>
        )}

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.9 }}
          type="submit"
          className="mt-8 w-full bg-yellow-400 text-blue-900 font-bold py-3 rounded-full shadow-md hover:bg-yellow-300"
        >
          Continue
        </motion.button>
      </form>

      <p className="absolute bottom-4 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>
    </div>
  );
};

export default Step4;
